<div [class]="classPrefix('MainPod')">
  <section [class]="classPrefix('Pod0')">
    <wml-form-zero [props]="mainForm"></wml-form-zero>
    <wml-button-one [props]="selectJobBtn"></wml-button-one>
  </section>
</div>
